export const matsmapsbaseobj = {
  '石材':{t:'classid',id:1,fname:'石材'},
  '石纹':{t:'classid',id:1,fname:'石材'},
  '布':{t:'classid',id:2,fname:'布纹'},
  '织布':{t:'classid',id:2,fname:'布纹'},
  '布纹':{t:'classid',id:2,fname:'布纹'},
  '木':{t:'classid',id:3,fname:'木纹|地板'},
  '木地板':{t:'classid',id:3,fname:'木纹|地板'},
  '皮':{t:'classid',id:4,fname:'皮革'},
  '皮革':{t:'classid',id:4,fname:'皮革'},
  '皮纹':{t:'classid',id:4,fname:'皮革'},
  '地毯':{t:'classid',id:5,fname:'地毯'},
  '金属':{t:'classid',id:6,fname:'金属'},
  '墙':{t:'classid',id:7,fname:'墙面'},
  '墙面':{t:'classid',id:7,fname:'墙面'},
  '透明':{t:'classid',id:8,fname:'透|半透明'},
  '画':{t:'classid',id:9,fname:'装饰画'},
  '装饰画':{t:'classid',id:9,fname:'装饰画'},
  '挂画':{t:'classid',id:9,fname:'装饰画'},
  '环境':{t:'classid',id:10,fname:'环境'},
  '建筑':{t:'classid',id:11,fname:'建筑'},
  '黑白':{t:'classid',id:79,fname:'黑白凹凸'},
  '黑白贴图':{t:'classid',id:79,fname:'黑白凹凸'},

  '大理石':{t:'classcid',id:13,type:1,fname:'石材'},
  '瓷砖':{t:'classcid',id:14,type:1,fname:'石材'},
  '文化石':{t:'classcid',id:15,type:1,fname:'石材'},
  '防滑砖':{t:'classcid',id:16,type:1,fname:'石材'},
  '仿古砖':{t:'classcid',id:16,type:1,fname:'石材'},
  '哑光砖':{t:'classcid',id:16,type:1,fname:'石材'},
  '马赛克':{t:'classcid',id:17,type:1,fname:'石材'},
  '石拼花':{t:'classcid',id:18,type:1,fname:'石材'},
  '岩石':{t:'classcid',id:19,type:1,fname:'石材'},
  '云石':{t:'classcid',id:20,type:1,fname:'石材'},
  '纺织布':{t:'classcid',id:21,type:2,fname:'布纹'},
  '麻布':{t:'classcid',id:21,type:2,fname:'布纹'},
  '格子布':{t:'classcid',id:22,type:2,fname:'布纹'},
  '条纹布':{t:'classcid',id:22,type:2,fname:'布纹'},
  '花纹布':{t:'classcid',id:22,type:2,fname:'布纹'},
  '绒布':{t:'classcid',id:23,type:2,fname:'布纹'},
  '丝绸':{t:'classcid',id:24,type:2,fname:'布纹'},
  '抱枕':{t:'classcid',id:25,type:2,fname:'布纹'},
  '枕头':{t:'classcid',id:25,type:2,fname:'布纹'},
  '窗帘':{t:'classcid',id:26,type:2,fname:'布纹'},
  '灯罩':{t:'classcid',id:27,type:2,fname:'布纹'},
  '木器漆':{t:'classcid',id:28,type:3,fname:'木纹|地板'},
  '木漆':{t:'classcid',id:28,type:3,fname:'木纹|地板'},
  '清漆':{t:'classcid',id:28,type:3,fname:'木纹|地板'},
  '混油':{t:'classcid',id:28,type:3,fname:'木纹|地板'},
  '木纹':{t:'classcid',id:29,type:3,fname:'木纹|地板'},
  '木材':{t:'classcid',id:29,type:3,fname:'木纹|地板'},
  '木料':{t:'classcid',id:29,type:3,fname:'木纹|地板'},
  '木贴皮':{t:'classcid',id:29,type:3,fname:'木纹|地板'},
  '木贴图':{t:'classcid',id:29,type:3,fname:'木纹|地板'},
  '条形木地板':{t:'classcid',id:30,type:3,fname:'木纹|地板'},
  '拼花木地板':{t:'classcid',id:31,type:3,fname:'木纹|地板'},
  '编制品':{t:'classcid',id:32,type:3,fname:'木纹|地板'},
  '藤编':{t:'classcid',id:32,type:3,fname:'木纹|地板'},
  '草席':{t:'classcid',id:32,type:3,fname:'木纹|地板'},
  '竹编':{t:'classcid',id:32,type:3,fname:'木纹|地板'},
  '竹席':{t:'classcid',id:32,type:3,fname:'木纹|地板'},
  '树皮':{t:'classcid',id:33,type:3,fname:'木纹|地板'},
  '旧木':{t:'classcid',id:33,type:3,fname:'木纹|地板'},
  '细纹皮':{t:'classcid',id:35,type:4,fname:'皮革'},
  '细皮':{t:'classcid',id:35,type:4,fname:'皮革'},
  '粗纹皮':{t:'classcid',id:36,type:4,fname:'皮革'},
  '粗皮':{t:'classcid',id:36,type:4,fname:'皮革'},
  '花纹皮':{t:'classcid',id:37,type:4,fname:'皮革'},
  '花皮':{t:'classcid',id:37,type:4,fname:'皮革'},
  '现代毯':{t:'classcid',id:38,type:5,fname:'地毯'},
  '现代地毯':{t:'classcid',id:38,type:5,fname:'地毯'},
  '中式地毯':{t:'classcid',id:39,type:5,fname:'地毯'},
  '中式毯':{t:'classcid',id:39,type:5,fname:'地毯'},
  '欧式毯':{t:'classcid',id:40,type:5,fname:'地毯'},
  '欧式地毯':{t:'classcid',id:40,type:5,fname:'地毯'},
  '动物毛毯':{t:'classcid',id:41,type:5,fname:'地毯'},
  '动物地毯':{t:'classcid',id:41,type:5,fname:'地毯'},
  '动物毯':{t:'classcid',id:41,type:5,fname:'地毯'},
  '绒毛地毯':{t:'classcid',id:42,type:5,fname:'地毯'},
  '绒毛毯':{t:'classcid',id:42,type:5,fname:'地毯'},
  '毛毯':{t:'classcid',id:42,type:5,fname:'地毯'},
  '抛光金属':{t:'classcid',id:44,type:6,fname:'金属'},
  '亮光金属':{t:'classcid',id:44,type:6,fname:'金属'},
  '高光金属':{t:'classcid',id:44,type:6,fname:'金属'},
  '拉丝金属':{t:'classcid',id:45,type:6,fname:'金属'},
  '拉丝':{t:'classcid',id:45,type:6,fname:'金属'},
  '哑光金属':{t:'classcid',id:46,type:6,fname:'金属'},
  '金箔':{t:'classcid',id:47,type:6,fname:'金属'},
  '银箔':{t:'classcid',id:47,type:6,fname:'金属'},
  '壁纸':{t:'classcid',id:49,type:7,fname:'墙面'},
  '壁布':{t:'classcid',id:49,type:7,fname:'墙面'},
  '花鸟墙纸':{t:'classcid',id:50,type:7,fname:'墙面'},
  '花鸟壁纸':{t:'classcid',id:50,type:7,fname:'墙面'},
  '壁纸背景':{t:'classcid',id:50,type:7,fname:'墙面'},
  '背景壁纸':{t:'classcid',id:50,type:7,fname:'墙面'},
  '乳胶漆':{t:'classcid',id:51,type:7,fname:'墙面'},
  '硅藻':{t:'classcid',id:52,type:7,fname:'墙面'},
  '水泥':{t:'classcid',id:52,type:7,fname:'墙面'},
  '砖墙':{t:'classcid',id:53,type:7,fname:'墙面'},
  '玻璃':{t:'classcid',id:55,type:8,fname:'透明'},
  '液体':{t:'classcid',id:56,type:8,fname:'透明'},
  '塑料':{t:'classcid',id:57,type:8,fname:'透明'},
  '现代画':{t:'classcid',id:59,type:9,fname:'装饰画'},
  '现代装饰画':{t:'classcid',id:59,type:9,fname:'装饰画'},
  '北欧画':{t:'classcid',id:60,type:9,fname:'装饰画'},
  '北欧装饰画':{t:'classcid',id:60,type:9,fname:'装饰画'},
  '中式画':{t:'classcid',id:61,type:9,fname:'装饰画'},
  '中式装饰画':{t:'classcid',id:61,type:9,fname:'装饰画'},
  '油画':{t:'classcid',id:62,type:9,fname:'装饰画'},
  '童趣画':{t:'classcid',id:63,type:9,fname:'装饰画'},
  '童趣装饰画':{t:'classcid',id:63,type:9,fname:'装饰画'},
  'HDRI':{t:'classcid',id:65,type:10,fname:'环境'},
  'hdr':{t:'classcid',id:65,type:10,fname:'环境'},
  '窗景':{t:'classcid',id:66,type:10,fname:'环境'},
  '外景':{t:'classcid',id:66,type:10,fname:'环境'},
  '窗外景':{t:'classcid',id:66,type:10,fname:'环境'},
  '建筑地面':{t:'classcid',id:67,type:11,fname:'建筑'},
  '建筑墙面':{t:'classcid',id:68,type:11,fname:'建筑'},
  '陶瓷':{t:'classcid',id:70,type:12,fname:'其他'},
  '瓷器':{t:'classcid',id:70,type:12,fname:'其他'},
  '图书':{t:'classcid',id:71,type:12,fname:'其他'},
  '封面':{t:'classcid',id:71,type:12,fname:'其他'},
  '书本':{t:'classcid',id:71,type:12,fname:'其他'},
  '水果':{t:'classcid',id:72,type:12,fname:'其他'},
  '植物':{t:'classcid',id:73,type:12,fname:'其他'},
  '花卉':{t:'classcid',id:73,type:12,fname:'其他'},
  '食品':{t:'classcid',id:74,type:12,fname:'其他'},
  '食物':{t:'classcid',id:74,type:12,fname:'其他'},
  '鱼缸':{t:'classcid',id:75,type:12,fname:'其他'},
  '火焰':{t:'classcid',id:76,type:12,fname:'其他'},
  '车漆':{t:'classcid',id:77,type:12,fname:'其他'},
  '自发光':{t:'classcid',id:78,type:12,fname:'其他'},
  '装饰花纹':{t:'classcid',id:80,type:79,fname:'黑白凹凸'},
  '法线':{t:'classcid',id:81,type:79,fname:'黑白凹凸'},
  '凹凸贴图':{t:'classcid',id:82,type:79,fname:'黑白凹凸'},
  '遮罩':{t:'classcid',id:83,type:79,fname:'黑白凹凸'},
  '高光贴图':{t:'classcid',id:83,type:79,fname:'黑白凹凸'},
  '电器':{t:'classcid',id:84,type:12,fname:'其他'},
  '陈设':{t:'classcid',id:85,type:12,fname:'其他'},
  '塑胶地板':{t:'classcid',id:86,type:12,fname:'其他'},
  '水磨石':{t:'classcid',id:87,type:1,fname:'石材'},
  '人造石':{t:'classcid',id:88,type:1,fname:'石材'},
}

export const modsbaseobj = {
  // '黑白':{t:'colorid',id:1},
  // '黑':{t:'colorid',id:2},
  // '黑色':{t:'colorid',id:2},
  // '灰':{t:'colorid',id:3},
  // '灰色':{t:'colorid',id:3},
  // '白':{t:'colorid',id:4},
  // '白色':{t:'colorid',id:4},
  // '金':{t:'colorid',id:5},
  // '金色':{t:'colorid',id:5},
  // '米色':{t:'colorid',id:6},
  // '米灰':{t:'colorid',id:6},
  // '浅黄':{t:'colorid',id:7},
  // '浅蓝':{t:'colorid',id:8},
  // '浅绿':{t:'colorid',id:9},
  // '浅红':{t:'colorid',id:10},
  // '浅紫':{t:'colorid',id:11},
  // '浅褐':{t:'colorid',id:12},
  // '深黄':{t:'colorid',id:13},
  // '深蓝':{t:'colorid',id:14},
  // '深绿':{t:'colorid',id:15},
  // '深红':{t:'colorid',id:16},
  // '深紫':{t:'colorid',id:17},
  // '深褐':{t:'colorid',id:18},
  // '黄色':{t:'colorid',id:19},
  // '橙色':{t:'colorid',id:20},
  // '蓝色':{t:'colorid',id:21},
  // '绿色':{t:'colorid',id:22},
  // '红色':{t:'colorid',id:23},
  // '紫色':{t:'colorid',id:24},
  // '褐色':{t:'colorid',id:25},

  '沙发':{t:'classid',id:1,fname:'沙发'},
  '椅':{t:'classid',id:2,fname:'椅子'},
  '椅子':{t:'classid',id:2,fname:'椅子'},
  '桌':{t:'classid',id:3,fname:'桌台'},
  '桌子':{t:'classid',id:3,fname:'桌台'},
  '台':{t:'classid',id:3,fname:'桌台'},
  '床':{t:'classid',id:4,fname:'床'},
  '柜':{t:'classid',id:5,fname:'柜子'},
  '柜子':{t:'classid',id:5,fname:'柜子'},
  '饰品':{t:'classid',id:6,fname:'饰品陈设'},
  '装饰品':{t:'classid',id:6,fname:'饰品陈设'},
  '陈设':{t:'classid',id:6,fname:'饰品陈设'},
  '植物':{t:'classid',id:7,fname:'植物'},
  '儿童家具':{t:'classid',id:8,fname:'儿童家具'},
  '灯':{t:'classid',id:9,fname:'灯具'},
  '办公':{t:'classid',id:10,fname:'办公家具'},
  '办公家具':{t:'classid',id:10,fname:'办公家具'},
  '构件':{t:'classid',id:11,fname:'构件'},
  '电器':{t:'classid',id:12,fname:'电器'},
  '厨房':{t:'classid',id:13,fname:'厨卫用具'},
  '洗手间':{t:'classid',id:13,fname:'厨卫用具'},
  '卫生间':{t:'classid',id:13,fname:'厨卫用具'},
  '器材':{t:'classid',id:14,fname:'器材设备'},
  '设备':{t:'classid',id:14,fname:'器材设备'},

  '休闲沙发':{t:'classcid',id:16,type:1,fname:'沙发'},
  '单人沙发':{t:'classcid',id:16,type:1,fname:'沙发'},
  '多人沙发':{t:'classcid',id:17,type:1,fname:'沙发'},
  '组合沙发':{t:'classcid',id:18,type:1,fname:'沙发'},
  '凳':{t:'classcid',id:19,type:1,fname:'沙发'},
  '脚踏':{t:'classcid',id:19,type:1,fname:'沙发'},
  '异形':{t:'classcid',id:20,type:1,fname:'沙发'},
  '贵妃':{t:'classcid',id:21,type:1,fname:'沙发'},
  '户外沙发':{t:'classcid',id:22,type:1,fname:'沙发'},
  '单椅':{t:'classcid',id:24,type:2,fname:'椅子'},
  '餐椅':{t:'classcid',id:24,type:2,fname:'椅子'},
  '躺椅':{t:'classcid',id:25,type:2,fname:'椅子'},
  '户外椅':{t:'classcid',id:26,type:2,fname:'椅子'},
  '公共椅':{t:'classcid',id:27,type:2,fname:'椅子'},
  '吊椅':{t:'classcid',id:28,type:2,fname:'椅子'},
  '吧台椅':{t:'classcid',id:29,type:2,fname:'椅子'},
  '吧椅':{t:'classcid',id:29,type:2,fname:'椅子'},
  '按摩椅':{t:'classcid',id:30,type:2,fname:'椅子'},
  '餐桌':{t:'classcid',id:32,type:3,fname:'桌台'},
  '茶桌':{t:'classcid',id:33,type:3,fname:'桌台'},
  '茶室':{t:'classcid',id:33,type:3,fname:'桌台'},
  '休闲桌椅':{t:'classcid',id:34,type:3,fname:'桌台'},
  '休闲组合':{t:'classcid',id:34,type:3,fname:'桌台'},
  '吧台':{t:'classcid',id:35,type:3,fname:'桌台'},
  '几':{t:'classcid',id:36,type:3,fname:'桌台'},
  '茶几':{t:'classcid',id:36,type:3,fname:'桌台'},
  '书桌':{t:'classcid',id:37,type:3,fname:'桌台'},
  '书房':{t:'classcid',id:37,type:3,fname:'桌台'},
  '梳妆':{t:'classcid',id:38,type:3,fname:'桌台'},
  '圆几':{t:'classcid',id:39,type:3,fname:'桌台'},
  '角几':{t:'classcid',id:39,type:3,fname:'桌台'},
  '单人床':{t:'classcid',id:41,type:4,fname:'床'},
  '双人床':{t:'classcid',id:42,type:4,fname:'床'},
  '床头柜':{t:'classcid',id:43,type:4,fname:'床'},
  '床榻':{t:'classcid',id:44,type:4,fname:'床'},
  '床头榻':{t:'classcid',id:44,type:4,fname:'床'},
  '按摩床':{t:'classcid',id:45,type:4,fname:'床'},
  '吊床':{t:'classcid',id:46,type:4,fname:'床'},
  '沙发床':{t:'classcid',id:47,type:4,fname:'床'},
  '酒柜':{t:'classcid',id:49,type:5,fname:'柜子'},
  '电视柜':{t:'classcid',id:50,type:5,fname:'柜子'},
  '鞋柜':{t:'classcid',id:51,type:5,fname:'柜子'},
  '端景':{t:'classcid',id:52,type:5,fname:'柜子'},
  '装饰柜':{t:'classcid',id:53,type:5,fname:'柜子'},
  '书柜':{t:'classcid',id:54,type:5,fname:'柜子'},
  '衣柜':{t:'classcid',id:55,type:5,fname:'柜子'},
  '博古':{t:'classcid',id:56,type:5,fname:'柜子'},
  '货架':{t:'classcid',id:57,type:5,fname:'柜子'},
  '货柜':{t:'classcid',id:57,type:5,fname:'柜子'},
  '储物':{t:'classcid',id:58,type:5,fname:'柜子'},
  '吊柜':{t:'classcid',id:59,type:5,fname:'柜子'},
  '壁柜':{t:'classcid',id:59,type:5,fname:'柜子'},
  '摆件':{t:'classcid',id:61,type:6,fname:'饰品陈设'},
  '挂件':{t:'classcid',id:62,type:6,fname:'饰品陈设'},
  '壁挂':{t:'classcid',id:62,type:6,fname:'饰品陈设'},
  '雕塑':{t:'classcid',id:63,type:6,fname:'饰品陈设'},
  '镜子':{t:'classcid',id:64,type:6,fname:'饰品陈设'},
  '窗帘':{t:'classcid',id:65,type:6,fname:'饰品陈设'},
  '地毯':{t:'classcid',id:66,type:6,fname:'饰品陈设'},
  '画':{t:'classcid',id:67,type:6,fname:'饰品陈设'},
  '装饰画':{t:'classcid',id:67,type:6,fname:'饰品陈设'},
  '挂画':{t:'classcid',id:67,type:6,fname:'饰品陈设'},
  '抱枕':{t:'classcid',id:68,type:6,fname:'饰品陈设'},
  '枕头':{t:'classcid',id:68,type:6,fname:'饰品陈设'},
  '花':{t:'classcid',id:70,type:6,fname:'饰品陈设'},
  '花瓶':{t:'classcid',id:70,type:6,fname:'饰品陈设'},
  '花艺':{t:'classcid',id:70,type:6,fname:'饰品陈设'},
  '插花':{t:'classcid',id:70,type:6,fname:'饰品陈设'},
  '表':{t:'classcid',id:71,type:6,fname:'饰品陈设'},
  '钟':{t:'classcid',id:71,type:6,fname:'饰品陈设'},
  '茶具':{t:'classcid',id:72,type:6,fname:'饰品陈设'},
  '茶艺':{t:'classcid',id:72,type:6,fname:'饰品陈设'},
  '喝茶':{t:'classcid',id:72,type:6,fname:'饰品陈设'},
  '背景墙':{t:'classcid',id:73,type:6,fname:'饰品陈设'},
  '鱼缸':{t:'classcid',id:74,type:6,fname:'饰品陈设'},
  '书':{t:'classcid',id:75,type:6,fname:'饰品陈设'},
  '书籍':{t:'classcid',id:75,type:6,fname:'饰品陈设'},
  '书本':{t:'classcid',id:75,type:6,fname:'饰品陈设'},
  '生活用品':{t:'classcid',id:76,type:6,fname:'饰品陈设'},
  '珠宝':{t:'classcid',id:77,type:6,fname:'饰品陈设'},
  '奖品':{t:'classcid',id:78,type:6,fname:'饰品陈设'},
  '旗帜':{t:'classcid',id:78,type:6,fname:'饰品陈设'},
  '奖杯':{t:'classcid',id:78,type:6,fname:'饰品陈设'},
  '树':{t:'classcid',id:80,type:7,fname:'植物'},
  '花草':{t:'classcid',id:81,type:7,fname:'植物'},
  '灌木':{t:'classcid',id:82,type:7,fname:'植物'},
  '竹子':{t:'classcid',id:83,type:7,fname:'植物'},
  '藤蔓':{t:'classcid',id:84,type:7,fname:'植物'},
  '植物墙':{t:'classcid',id:84,type:7,fname:'植物'},
  '盆栽':{t:'classcid',id:85,type:7,fname:'植物'},
  '儿童床':{t:'classcid',id:87,type:8,fname:'儿童家具'},
  '儿童桌椅':{t:'classcid',id:88,type:8,fname:'儿童家具'},
  '儿童柜子':{t:'classcid',id:89,type:8,fname:'儿童家具'},
  '儿童用品':{t:'classcid',id:90,type:8,fname:'儿童家具'},
  '玩具':{t:'classcid',id:91,type:8,fname:'儿童家具'},
  '吊灯':{t:'classcid',id:93,type:9,fname:'灯具'},
  '落地灯':{t:'classcid',id:94,type:9,fname:'灯具'},
  '吸顶灯':{t:'classcid',id:95,type:9,fname:'灯具'},
  '台灯':{t:'classcid',id:96,type:9,fname:'灯具'},
  '户外灯':{t:'classcid',id:97,type:9,fname:'灯具'},
  '壁灯':{t:'classcid',id:98,type:9,fname:'灯具'},
  '儿童灯':{t:'classcid',id:99,type:9,fname:'灯具'},
  '烛台':{t:'classcid',id:100,type:9,fname:'灯具'},
  '筒灯':{t:'classcid',id:101,type:9,fname:'灯具'},
  '射灯':{t:'classcid',id:101,type:9,fname:'灯具'},
  '装饰灯':{t:'classcid',id:102,type:9,fname:'灯具'},
  '舞台灯':{t:'classcid',id:103,type:9,fname:'灯具'},
  '办公灯':{t:'classcid',id:104,type:9,fname:'灯具'},
  '接待台':{t:'classcid',id:106,type:10,fname:'办公家具'},
  '办公桌':{t:'classcid',id:107,type:10,fname:'办公家具'},
  '办公椅':{t:'classcid',id:108,type:10,fname:'办公家具'},
  '滚轮椅':{t:'classcid',id:108,type:10,fname:'办公家具'},
  '办公沙发':{t:'classcid',id:109,type:10,fname:'办公家具'},
  '会议桌':{t:'classcid',id:110,type:10,fname:'办公家具'},
  '文件柜':{t:'classcid',id:111,type:10,fname:'办公家具'},
  '办公用品':{t:'classcid',id:112,type:10,fname:'办公家具'},
  '卡位':{t:'classcid',id:113,type:10,fname:'办公家具'},
  '员工办公':{t:'classcid',id:113,type:10,fname:'办公家具'},
  '员工位':{t:'classcid',id:113,type:10,fname:'办公家具'},
  '门':{t:'classcid',id:115,type:11,fname:'构件'},
  '窗':{t:'classcid',id:116,type:11,fname:'构件'},
  '柱子':{t:'classcid',id:117,type:11,fname:'构件'},
  '雕花':{t:'classcid',id:118,type:11,fname:'构件'},
  '壁炉':{t:'classcid',id:119,type:11,fname:'构件'},
  '五金':{t:'classcid',id:120,type:11,fname:'构件'},
  '楼梯栏杆':{t:'classcid',id:121,type:11,fname:'构件'},
  '栏杆':{t:'classcid',id:121,type:11,fname:'构件'},
  '线条':{t:'classcid',id:122,type:11,fname:'构件'},
  '护墙':{t:'classcid',id:123,type:11,fname:'构件'},
  '大理石拼花':{t:'classcid',id:124,type:11,fname:'构件'},
  '屏风':{t:'classcid',id:125,type:11,fname:'构件'},
  '花格':{t:'classcid',id:125,type:11,fname:'构件'},
  '音响':{t:'classcid',id:127,type:12,fname:'电器'},
  '电视':{t:'classcid',id:128,type:12,fname:'电器'},
  '空调':{t:'classcid',id:129,type:12,fname:'电器'},
  '风扇':{t:'classcid',id:129,type:12,fname:'电器'},
  '电脑':{t:'classcid',id:130,type:12,fname:'电器'},
  '手机':{t:'classcid',id:131,type:12,fname:'电器'},
  '相机':{t:'classcid',id:131,type:12,fname:'电器'},
  '投影':{t:'classcid',id:132,type:12,fname:'电器'},
  '洗衣机':{t:'classcid',id:133,type:12,fname:'电器'},
  '冰箱':{t:'classcid',id:134,type:12,fname:'电器'},
  '冰柜':{t:'classcid',id:134,type:12,fname:'电器'},
  '日用电器':{t:'classcid',id:135,type:12,fname:'电器'},
  '小家电':{t:'classcid',id:135,type:12,fname:'电器'},
  '橱柜':{t:'classcid',id:137,type:13,fname:'厨卫用具'},
  '餐具':{t:'classcid',id:138,type:13,fname:'厨卫用具'},
  '碗':{t:'classcid',id:138,type:13,fname:'厨卫用具'},
  '碟':{t:'classcid',id:138,type:13,fname:'厨卫用具'},
  '筷':{t:'classcid',id:138,type:13,fname:'厨卫用具'},
  '厨房电器':{t:'classcid',id:139,type:13,fname:'厨卫用具'},
  '台盆':{t:'classcid',id:140,type:13,fname:'厨卫用具'},
  '食品':{t:'classcid',id:141,type:13,fname:'厨卫用具'},
  '食物':{t:'classcid',id:141,type:13,fname:'厨卫用具'},
  '酒':{t:'classcid',id:142,type:13,fname:'厨卫用具'},
  '饮料':{t:'classcid',id:142,type:13,fname:'厨卫用具'},
  '浴缸':{t:'classcid',id:143,type:13,fname:'厨卫用具'},
  '淋浴':{t:'classcid',id:144,type:13,fname:'厨卫用具'},
  '桑拿':{t:'classcid',id:144,type:13,fname:'厨卫用具'},
  '浴室柜':{t:'classcid',id:145,type:13,fname:'厨卫用具'},
  '浴室架':{t:'classcid',id:145,type:13,fname:'厨卫用具'},
  '便器':{t:'classcid',id:146,type:13,fname:'厨卫用具'},
  '马桶':{t:'classcid',id:146,type:13,fname:'厨卫用具'},
  '卫浴小件':{t:'classcid',id:147,type:13,fname:'厨卫用具'},
  '洗涤日用':{t:'classcid',id:148,type:13,fname:'厨卫用具'},
  '卫浴用品':{t:'classcid',id:148,type:13,fname:'厨卫用具'},
  '体育':{t:'classcid',id:150,type:14,fname:'器材设备'},
  '医疗':{t:'classcid',id:151,type:14,fname:'器材设备'},
  '游乐':{t:'classcid',id:152,type:14,fname:'器材设备'},
  '音乐':{t:'classcid',id:153,type:14,fname:'器材设备'},
  '美术':{t:'classcid',id:153,type:14,fname:'器材设备'},
  '汽车':{t:'classcid',id:154,type:14,fname:'器材设备'},
  '设施':{t:'classcid',id:155,type:14,fname:'器材设备'},
  '军用':{t:'classcid',id:156,type:14,fname:'器材设备'},
  '工业设备':{t:'classcid',id:157,type:14,fname:'沙器材设备发'},
  '消防':{t:'classcid',id:158,type:14,fname:'器材设备'},
  '人物':{t:'classcid',id:160,type:15,fname:'人物动物'},
  '动物':{t:'classcid',id:161,type:15,fname:'人物动物'},

  // '现代':{t:'styleid',id:1},
  // '后现代':{t:'styleid',id:2},
  // '中式':{t:'styleid',id:3},
  // '新中式':{t:'styleid',id:4},
  // '欧式':{t:'styleid',id:5},
  // '简欧':{t:'styleid',id:6},
  // '欧式古典':{t:'styleid',id:7},
  // '古典欧':{t:'styleid',id:7},
  // '美式':{t:'styleid',id:8},
  // '法式':{t:'styleid',id:9},
  // '新古典':{t:'styleid',id:10},
  // '北欧':{t:'styleid',id:11},
  // '工业风':{t:'styleid',id:12},
  // '东南亚':{t:'styleid',id:13},
  // '地中海':{t:'styleid',id:14},
  // '日韩':{t:'styleid',id:15},
  // '自然风':{t:'styleid',id:16},
  // '洛可可':{t:'styleid',id:17},
  // '巴洛克':{t:'styleid',id:18},
}

